<template>
    <section class="main_precedent_container new_main_precedent_container">
        <div class="container">
            <div class="row">
                <div class="col-12 title">
                    <h2><b>내돈내놔</b> 성공사례</h2>
                </div>
                <div class="col-12 content-box">
                    <ul>
                        <li
                            v-for="list in lists"
                            :key="list.id"
                            :class="[
                                list.type === '음주운전' && 'drunk',
                                list.type === '음란물' && 'porno',
                                list.type === 3 && 'c',
                                list.type === 4 && 'd',
                                list.type === 1 && 'f'
                            ]">
                            <h2 class="card-title">{{ list.type }}, {{ list.result }}</h2>
                            <h4 class="card-date">{{ list.occured_at }}</h4>

                            <!-- template v-if="list.type === '1'" -->
                            <!-- template -->
                                <h3 class="card-txt">
                                    {{ list.is_unlicensed }} 음주측정결과
                                    {{ list.bac }}
                                    {{ list.occured_in }}
                                </h3>
                                <h3 class="card-txt">
                                    {{ list.same_record }}
                                    {{ list.other_record }}
                                </h3>
                                <h3 class="card-txt" v-show="list.isCourtName">
                                    {{ list.court_name }}
                                </h3>
                            <!-- /template -->

                        </li>
                    </ul>
                    <div class="btn-box btn-more">
                        <button @click="plusList" v-show="btnResult">
                            성공사례 더 보기
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-precedent-popup" :class="[{ active: isActive }]">
            <div class="popup-content">
                <div class="popup-item">
                    <div class="popup-close-btn-box">
                        <button @click="close">
                            <span class="line1"></span>
                            <span class="line2"></span>
                        </button>
                    </div>

                    <button
                        class="pagination-btn left"
                        @click="nextMove(modal.id)"
                        v-show="btnLast"
                    >
                        <i class="fas fa-chevron-left fa-2x"></i>
                    </button>
                    <button
                        class="pagination-btn right"
                        @click="prevMove(modal.id)"
                        v-show="btnFirst"
                    >
                        <i class="fas fa-chevron-right fa-2x"></i>
                    </button>

                    <div class="itme-content">
                        <ul class="table-box">
                            <li>
                                <div class="left">관할법원</div>
                                <div class="right">{{ modal.court_name }}</div>
                            </li>
                            <li>
                                <div class="left">사건번호</div>
                                <div class="right">
                                    {{ modal.docket_number }}
                                </div>
                            </li>
                            <li>
                                <div class="left">범행일시</div>
                                <div class="right">{{ modal.occured_at }}</div>
                            </li>

                            <template v-if="modal.type === '1'">
                                <li>
                                    <div class="left">단속시점</div>
                                    <div class="right">
                                        {{ modal.occured_time }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">단속장소</div>
                                    <div class="right">
                                        {{ modal.occured_in }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">도시지역여부</div>
                                    <div class="right">
                                        {{ modal.is_downtown }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">주행도로</div>
                                    <div class="right">
                                        {{ modal.driven_road }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">주행거리(m단위)</div>
                                    <div class="right">
                                        {{ modal.driven_distance }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">단속경위</div>
                                    <div class="right">
                                        {{ modal.crackdown }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">나이</div>
                                    <div class="right">{{ modal.age }}</div>
                                </li>
                                <li>
                                    <div class="left">직업</div>
                                    <div class="right">{{ modal.jobs }}</div>
                                </li>
                                <li>
                                    <div class="left">운전차량</div>
                                    <div class="right">
                                        {{ modal.driven_car }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">음주수치</div>
                                    <div class="right">{{ modal.bac }}</div>
                                </li>
                                <li>
                                    <div class="left">무면허여부</div>
                                    <div class="right">
                                        {{ modal.is_unlicensed }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">동종전과횟수</div>
                                    <div class="right">
                                        {{ modal.same_record }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">최근2년내동종전과</div>
                                    <div class="right">
                                        {{ modal.same_record_2years }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">동종출소3년이내</div>
                                    <div class="right">
                                        {{ modal.same_record_release_3years }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        3년이내 이종전과 여부
                                    </div>
                                    <div class="right">
                                        {{ modal.other_record }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        동종전과 집행유예 기간 여부
                                    </div>
                                    <div class="right">
                                        {{ modal.is_same_suspended }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        이종전과 집행유예 기간 여부
                                    </div>
                                    <div class="right">
                                        {{ modal.is_other_suspended }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">대물사고 합의 여부</div>
                                    <div class="right">
                                        {{ modal.is_pi_agreement }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">대인사고 합의 여부</div>
                                    <div class="right">
                                        {{ modal.is_bi_agreement }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">대리운전 시도 여부</div>
                                    <div class="right">
                                        {{ modal.is_designated }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        긴급한 운전 필요성 여부
                                    </div>
                                    <div class="right">
                                        {{ modal.is_emergency }}
                                    </div>
                                </li>
                            </template>

                            <template v-if="modal.type === '2'">
                                <li>
                                    <div class="left">아동음란물 여부</div>
                                    <div class="right">{{ modal.child }}</div>
                                </li>
                                <li>
                                    <div class="left">
                                        몰래카메라 또는 협박에 의해 제작된
                                        음란물이 포함되어 있나요
                                    </div>
                                    <div class="right">{{ modal.crime }}</div>
                                </li>
                                <li v-show="modal.making">
                                    <div class="left">
                                        아동음란물의 제작에 관여된 사실이 있나요
                                    </div>
                                    <div class="right">{{ modal.making }}</div>
                                </li>
                                <li v-show="modal.sales">
                                    <div class="left">
                                        처음부터 영리를 목적으로 제작한
                                        아동음란물인가요
                                    </div>
                                    <div class="right">{{ modal.sales }}</div>
                                </li>
                                <li v-show="modal.spread">
                                    <div class="left">
                                        다른곳에 유포하셨나요?
                                    </div>
                                    <div class="right">{{ modal.spread }}</div>
                                </li>
                                <li v-show="modal.intentionality">
                                    <div class="left">유포의 유형</div>
                                    <div class="right">
                                        {{ modal.intentionality }}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        동종의 범죄로 처벌받은 사실이 있나요
                                    </div>
                                    <div class="right">
                                        {{ modal.previous_conviction }}
                                    </div>
                                </li>
                            </template>

                            <template v-if="modal.type === '3'"></template>

                            <template v-if="modal.type === '4'"></template>

                            <li>
                                <div class="left">결과</div>
                                <div class="right">{{ modal.result }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="popup-back"></div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            lists: [],
            num: 6,
            isActive: false,
            modal: [],
            last: "",
            first: 1,
            btnLast: true,
            btnFirst: true,
            start: true,
            btnResult: true
        };
    },
    components: {},

    async mounted() {
        try {
            const res = await axios({
                method: "GET",
                url: "/api/leadingcase/"
            });
            // console.log(res.data);
            this.last = res.data.now[0].id;
            // console.log(res.data);
            res.data.now.forEach(i => {
                this.result(i);
            });
        } catch {
        } finally {
        }
    },
    methods: {
        async plusList() {
            try {
                const res = await axios({
                    method: "GET",
                    url: `/api/leadingcase/${this.num}`
                });
                res.data.now.forEach(i => {
                    this.result(i);
                });
                this.num = this.num + 6;
                if (res.data.next.length < 1) {
                    this.btnResult = false;
                }
            } catch {
            } finally {
            }
        },
        result(i) {
            let is_unlicensed;

            if (i.is_unlicensed === "정보없음") {
                is_unlicensed = "";
            } else {
                is_unlicensed = i.is_unlicensed + ",";
            }

            let occured_in;
            if (i.occured_in === "정보없음") {
                occured_in = "";
            } else {
                occured_in = ", " + i.occured_in;
            }

            let same_record;
            if (i.same_record === "정보없음") {
                same_record = "";
            } else if (i.same_record == 0) {
                same_record = "동종전과 없음";
            } else if (i.same_record > 6) {
                same_record = "동종전과 7회 이상";
            } else {
                same_record = "동종전과" + i.same_record + "회";
            }

            let other_record;
            if (i.other_record === "정보없음") {
                other_record = "";
            } else if (i.other_record === "O") {
                other_record = ", 최근 3년이내 이종전과 없음";
            } else {
                other_record = ", 최근 3년이내 이종전과 있음";
            }

            let is_courtName;
            if (i.court_name === "정보없음") {
                is_courtName = false;
            } else {
                is_courtName = true;
            }
            const date = i.occured_at.split("-");

            let type;
            if (i.type == 1) {
                type = "음주운전";
                this.lists.push({
                    type: type,
                    id: i.id,
                    result: i.result,
                    is_unlicensed: is_unlicensed,
                    bac: i.bac,
                    court_name: i.court_name,
                    same_record: same_record,
                    other_record: other_record,
                    occured_in: occured_in,
                    occured_at: `${date[0]}년 ${date[1]}월`,
                    isCourtName: is_courtName
                });
            } else if (i.type == 2) {
                type = "음란물";

                let data = JSON.parse(i.data);
                let child = data.child;
                let crime = data.crime;
                let making = data.making;
                let sales = data.sales;
                let spread = data.spread;
                let intentionality = data.intentionality;
                let previous_conviction = data.previous_conviction;

                this.lists.push({
                    type: type,
                    id: i.id,
                    child: child,
                    crime: crime,
                    making: making,
                    sales: sales,
                    spread: spread,
                    intentionality: intentionality,
                    previous_conviction: previous_conviction,
                    result: i.result,
                    is_unlicensed: is_unlicensed,
                    bac: i.bac,
                    court_name: i.court_name,
                    same_record: same_record,
                    other_record: other_record,
                    occured_in: occured_in,
                    occured_at: `${date[0]}년 ${date[1]}월`,
                    isCourtName: is_courtName
                });
            } else if (i.type == 3) {
                type = "사기범죄";
            } else if (i.type == 4) {
                type = "성범죄";
            }
        },
        async ditail(id) {
            try {
                const res = await axios({
                    method: "GET",
                    url: `/api/leadingcase/get/${id}`
                });
                this.popupDetail(res.data.now);
                this.isActive = true;
                if (!res.data.prev) {
                    this.btnFirst = false;
                } else {
                    this.btnFirst = true;
                }
            } catch {
            } finally {
            }
        },
        async nextMove(id) {
            if (this.start) {
                this.start = false;
                try {
                    const res = await axios({
                        method: "GET",
                        url: `/api/leadingcase/next/${id}`
                    });
                    this.start = true;
                    this.popupDetail(res.data);
                    this.btnFirst = true;
                } catch {
                } finally {
                }
            }
        },
        async prevMove(id) {
            if (this.start) {
                this.start = false;
                try {
                    const res = await axios({
                        method: "GET",
                        url: `/api/leadingcase/prev/${id}`
                    });
                    this.start = true;
                    this.popupDetail(res.data.now);

                    if (!res.data.prev) {
                        this.btnFirst = false;
                    } else {
                        this.btnFirst = true;
                    }
                } catch {
                } finally {
                }
            }
        },
        popupDetail(res) {
            // console.log(res)
            if (this.last === res.id) {
                this.btnLast = false;
            } else {
                this.btnLast = true;
            }
            const date = res.occured_at.split("-");
            this.modal = [];

            this.modal.type = res.type;

            if (res.type == 2) {
                let data = JSON.parse(res.data);
                this.modal.child = data.child;
                this.modal.crime = data.crime;
                this.modal.making = data.making;
                this.modal.sales = data.sales;
                this.modal.spread = data.spread;
                this.modal.intentionality = data.intentionality;
                this.modal.previous_conviction = data.previous_conviction;
            }

            this.modal.id = res.id;
            this.modal.court_name = res.court_name;
            this.modal.docket_number = res.docket_number;
            this.modal.age = res.age;
            this.modal.bac = res.bac;
            this.modal.occured_at = `${date[0]}년 ${date[1]}월`;
            this.modal.occured_in = res.occured_in;
            this.modal.is_downtown = res.is_downtown;
            this.modal.driven_distance = res.driven_distance;
            this.modal.jobs = res.jobs;
            this.modal.is_unlicensed = res.is_unlicensed;
            this.modal.same_record = res.same_record;
            this.modal.other_record = res.other_record;
            this.modal.is_same_suspended = res.is_same_suspended;
            this.modal.is_other_suspended = res.is_other_suspended;
            this.modal.is_pi_agreement = res.is_pi_agreement;
            this.modal.is_bi_agreement = res.is_bi_agreement;
            this.modal.is_designated = res.is_designated;
            this.modal.is_emergency = res.is_emergency;
            this.modal.occured_time = res.occured_time;
            this.modal.driven_road = res.driven_road;
            this.modal.crackdown = res.crackdown;
            this.modal.driven_car = res.driven_car;
            this.modal.same_record_2years = res.same_record_2years;
            this.modal.same_record_release_3years =
                res.same_record_release_3years;
            this.modal.result = res.result;
        },
        close() {
            this.isActive = false;
            this.modal = [];
        }
    }
};
</script>

<style scoped>
/**********************************/
/****** main-precedent-popup ******/
/**********************************/

.main_precedent_container {
    padding: 100px 0;
    background: #f3f3f3;
}

.main_precedent_container .title h2 {
    color: #2e2d2d;
    font-size: 1.875rem;
    font-weight: bold;
    margin-bottom: 0;
    padding-bottom: 40px;
}

.main_precedent_container .content-box > ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.main_precedent_container .content-box > ul li {
    width: 47.5%;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #e7e7e7;
    background: #fff;
    box-shadow: 0 30px 60px 12px rgba(0, 0, 33, 0.05),
        0 4px 24px 0 rgba(0, 0, 33, 0.05), 0 0 1px 0 rgba(0, 0, 33, 0.09);
    margin-bottom: 30px;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
}

/* .main_precedent_container .content-box > ul li::before {
    content: "";
    display: block;
    width: 10px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #3b4960;
} */

/* .main_precedent_container .content-box > ul li.drunk::before {
  background-color: #f0b756;
} */
/* .main_precedent_container .content-box > ul li::before {
    background-color: #475fae;
} */

.main_precedent_container .content-box > ul li .txt1 {
    font-size: 1.4rem;
    color: #196bed;
    font-weight: bold;
}

.main_precedent_container .content-box > ul li .txt2 {
    font-size: 1rem;
    color: #362e2c;
    font-weight: bold;
    display: block;
    margin-top: 15px;
    margin-bottom: 20px;
}

.main_precedent_container .content-box > ul li .txt3 {
    font-size: 0.875rem;
    color: #362e2c;
    font-weight: bold;
    display: block;
}

.main_precedent_container .content-box > ul li .txt4 {
    font-size: 0.875rem;
    color: #362e2c;
    display: block;
    margin-top: 10px;
    margin-bottom: 30px;
}

.main_precedent_container .content-box > ul li .txt5 {
    font-size: 12px;
    float: left;
}

.main_precedent_container .content-box > ul li .txt6 {
    float: right;
    margin-right: 15px;
}

.main_precedent_container .content-box > ul li .txt6 button {
    font-size: 12px;
    color: #196bed;
    padding-bottom: 3px;
    border-bottom: 1px solid #196bed;
}

.main_precedent_container .content-box .btn-box button {
    display: block;
    height: 60px;
    line-height: 60px;
    color: #fff;
    background-color: #207bf9;
    font-weight: bold;
    text-align: center;
    width: 260px;
    border-radius: 10px;
    margin: 0 auto;
    font-size: 16px;
}

.main-precedent-popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 400;
    display: none;
}
.main-precedent-popup.active {
    display: flex;
}
.main-precedent-popup .popup-content {
    position: relative;
    z-index: 400;
    width: 100%;
    margin: auto;
    padding: 10px 40px;
    box-sizing: border-box;
}
.main-precedent-popup .popup-content .popup-item {
    background-color: #fff;
    max-width: 1000px;
    margin: 0 auto;
    position: relative;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    padding: 20px;
    box-sizing: border-box;
}
.main-precedent-popup .popup-content .popup-close-btn-box {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    right: -40px;
}
.main-precedent-popup .popup-content .popup-close-btn-box button {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
}
.main-precedent-popup .popup-content .popup-close-btn-box button span {
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 2px;
    background-color: #fff;
}
.main-precedent-popup .popup-content .popup-close-btn-box button span.line1 {
    transform: translateY(-50%) rotate(45deg);
}
.main-precedent-popup .popup-content .popup-close-btn-box button span.line2 {
    transform: translateY(-50%) rotate(-45deg);
}
.main-precedent-popup .popup-content .pagination-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}
.main-precedent-popup .popup-content .pagination-btn.left {
    left: -40px;
}
.main-precedent-popup .popup-content .pagination-btn.right {
    right: -40px;
}
.main-precedent-popup .table-box {
    border: 1px solid #e5e5e5;
}
.main-precedent-popup .table-box li {
    display: flex;
    border-bottom: 1px solid #e5e5e5;
}
.main-precedent-popup .table-box li:last-child {
    border-bottom: 0;
}
.main-precedent-popup .table-box li div {
    width: 50%;
    text-align: center;
    font-size: 1rem;
    font-weight: bold;
    padding: 10px 0;
}
.main-precedent-popup .table-box li div.left {
    background-color: #f3f5f8;
    color: #343232;
}
.main-precedent-popup .table-box li div.right {
    color: #3b4960;
    font-weight: normal;
}

.main-precedent-popup .table-box li:last-child div.left {
    background-color: #797979;
    color: #fff;
}

.main-precedent-popup .table-box li:last-child div.right {
    background-color: #207bf9;
    color: #fff;
}

.main-precedent-popup .popup-back {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
}

@media screen and (max-width: 991px) {
    .main_precedent_container .content-box > ul li {
        width: 100%;
    }
}
</style>
